import { z } from "zod";

export const GetStayAiSubscriptionPlanGroupsResponseBodySchema = z.object({
  subscriptionPlanGroups: z.any().array(),
});

export type GetStayAiSubscriptionPlanGroupsResponseBodyType = z.infer<
  typeof GetStayAiSubscriptionPlanGroupsResponseBodySchema
>;
